import { apiClient as api } from "./httpClient";

/**
 * Consumo de IA da clínica (harness H0 §4.4): totais, quebras por origem, agente, modelo e dia, e o orçamento do mês.
 * Valores em US$ (moeda do provedor, D-HAR-9). O Suporte Clinic4Us é custo da plataforma e vem à parte.
 */
export interface AiUsageGroup {
  key: string;
  name: string;
  calls: number;
  tokens: number;
  costUsd: number;
}

export interface AiUsageDay {
  day: string;
  calls: number;
  costUsd: number;
}

export interface AiUsageReport {
  from: string;
  to: string;
  calls: number;
  errors: number;
  inputTokens: number;
  outputTokens: number;
  cacheTokens: number;
  costUsd: number;
  platformCostUsd: number;
  unpricedCalls: number;
  monthlyBudgetUsd: number | null;
  budgetAlertPercent: number;
  budgetBlocks: boolean;
  monthSpentUsd: number;
  bySource: AiUsageGroup[];
  byAgent: AiUsageGroup[];
  byModel: AiUsageGroup[];
  byDay: AiUsageDay[];
}

export const aiUsageService = {
  get: async (entityId: string, from?: string, to?: string): Promise<AiUsageReport> => {
    const response = await api.get(`/ai-usage/${entityId}`, { params: { from: from || undefined, to: to || undefined } });
    return response.data;
  },
};
